(function () {
  var hideTimer;

  function flashCart() {
    var buttons = document.querySelectorAll('.cart-drawer-button, .dock__item[aria-controls="CartDrawer"]');
    if (!buttons.length) return;
    buttons.forEach(function (button) {
      button.classList.add('ff-cart-added');
    });
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      buttons.forEach(function (button) {
        button.classList.remove('ff-cart-added');
      });
    }, 2400);
  }

  function markAdded() {
    var atc = document.getElementById('ff-atc');
    if (atc && !atc.disabled) {
      var previous = atc.innerHTML;
      atc.classList.add('ff-atc-added');
      atc.textContent = 'Added';
      window.setTimeout(function () {
        atc.classList.remove('ff-atc-added');
        atc.innerHTML = previous;
      }, 2000);
    }

    var sticky = document.getElementById('ff-sticky-atc');
    if (sticky) {
      var stickyPrevious = sticky.textContent;
      sticky.textContent = 'Added';
      window.setTimeout(function () {
        sticky.textContent = stickyPrevious;
      }, 2000);
    }
  }

  document.addEventListener('ajaxProduct:added', function () {
    flashCart();
    markAdded();
  });

  // Back/forward navigation can restore a cached page whose cart count and
  // drawer predate an add-to-cart (e.g. returning from checkout). Re-read the
  // live cart and refresh the header count + drawer when they disagree.
  function resyncCartFromServer() {
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        var counts = document.querySelectorAll('cart-count');
        var shown = counts.length ? parseInt(counts[0].textContent, 10) : 0;
        if (isNaN(shown)) shown = 0;
        if (shown === cart.item_count) return;
        counts.forEach(function (count) {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      })
      .catch(function () {});
  }

  window.addEventListener('pageshow', function (event) {
    var entries = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation') : [];
    var navType = entries && entries[0] ? entries[0].type : '';
    if (event.persisted || navType === 'back_forward') resyncCartFromServer();
  });
})();
